import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Select, Divider, message, Spin, Row, Col, Radio } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import AddClientDTO from 'src/models/client/AddClientDTO';
import UpdateClientDTO from 'src/models/client/UpdateClientDTO';
import KeyValueListDTO from 'src/models/generic/KeyValueListDTO';
import KeyValueDTO from 'src/models/generic/KeyValueDTO';
import ClientSubscriptions from './ClientSubscriptions';
import { ClientSubscriptionsProps } from './ClientSubscriptions';

import AdminFullSyncReports from './AdminFullSyncReports';

import { AdminFullSyncReportsProps } from './AdminFullSyncReports';

import ClientApiController from 'src/api/ClientApiController';

import StateApiController from 'src/api/StateApiController';
import { GenericFormItem } from 'src/utils/FormUtil';
import Languages from 'src/constants/Languages';

const RadioGroup = Radio.Group;

interface RouteParams {
  id: string;
}

interface AddEditClientProps extends PageProps<RouteParams>, LocalizeContextProps {}

interface AddEditClientState {
  loading: boolean;
  isSubmitting: boolean;
  currentClient: UpdateClientDTO;
  clientTypes: KeyValueDTO<string, number>[];
  countries: KeyValueDTO<string, number>[];
  states: KeyValueDTO<string, number>[];
}

interface ClientFormProps {
  currentClient: UpdateClientDTO;
  countries: KeyValueDTO<string, number>[];
  states: KeyValueDTO<string, number>[];
  clientTypes: KeyValueDTO<string, number>[];
  translate: (id: any) => any;
  onChange: (changedFields: any[]) => void;
}

interface FullSyncFormProps {
  currentClient: UpdateClientDTO;
  countries: KeyValueDTO<string, number>[];
  states: KeyValueDTO<string, number>[];
  clientTypes: KeyValueDTO<string, number>[];
  translate: (id: any) => any;
  onChange: (changedFields: any[]) => void;
}

interface AdminSyncResultsProps {
  districtName: string;
}

// Form
let ClientForm = Form.create({
  onFieldsChange(props: ClientFormProps, changedFields: any[]) {
    props.onChange(changedFields);
  },
})(
  class extends React.Component<ClientFormProps & FormComponentProps> {
    constructor(props: ClientFormProps & FormComponentProps) {
      super(props);
    }

    private generateOptionsForSelect(keyValues: KeyValueDTO<string, number>[]): JSX.Element[] {
      return keyValues.map((keyValue) => (
        <Select.Option value={keyValue.value} key={keyValue.key} title={keyValue.key}>
          {keyValue.key}
        </Select.Option>
      ));
    }

    validateState = (rule, value, callback) => {
      value ? callback() : callback(' ');
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
      let translatedLabel = this.props.translate(translationId);

      let rules = [];

      if (required) {
        rules.push({ required: true, message: this.props.translate('admin.common.requiredRule') });
      }

      if (id === 'stateId') {
        rules.push({ validator: this.validateState });
      }

      if (visible) {
        return (
          <Form.Item label={translatedLabel}>
            {this.props.form.getFieldDecorator(id, {
              initialValue: initialValue,
              rules: rules,
            })(inputType)}
          </Form.Item>
        );
      }
    }

    render() {
      let choosenClientType = this.props.clientTypes.find((x) => x.value === this.props.currentClient.clientTypeId).key.toLowerCase();
      let isStateClient = choosenClientType === 'state';

      return (
        <Row>
          <Col span={12}>
            <Form className="admin-form">
              <GenericFormItem form={this.props.form} labelId={'admin.addEditClient.formItem1'} id="clientName" initialValue={this.props.currentClient.clientName}>
                <Input autoComplete="off" />
              </GenericFormItem>

              {this.renderStandardFormItem(
                'admin.addEditClient.formItem2',
                'clientTypeId',
                this.props.currentClient.clientTypeId,
                this.props.currentClient.clientId ? (
                  <Select disabled>{this.generateOptionsForSelect(this.props.clientTypes)}</Select>
                ) : (
                  <Select>{this.generateOptionsForSelect(this.props.clientTypes)}</Select>
                )
              )}

              {this.renderStandardFormItem(
                'admin.addEditClient.formItem3',
                'countryId',
                this.props.currentClient.countryId,
                this.props.currentClient.clientId ? (
                  <Select disabled>{this.generateOptionsForSelect(this.props.countries)}</Select>
                ) : (
                  <Select>{this.generateOptionsForSelect(this.props.countries)}</Select>
                ),
                isStateClient
              )}

              {this.renderStandardFormItem(
                'admin.addEditClient.formItem4',
                'stateId',
                this.props.currentClient.stateId,
                this.props.currentClient.clientId ? <Select disabled>{this.generateOptionsForSelect(this.props.states)}</Select> : <Select>{this.generateOptionsForSelect(this.props.states)}</Select>,
                isStateClient
              )}

              {this.renderStandardFormItem('admin.addEditClient.' + choosenClientType, 'districtSchoolName', this.props.currentClient.districtSchoolName, <Input autoComplete="off" />, !isStateClient)}

              <GenericFormItem form={this.props.form} labelId="admin.addEditClient.formItem5" id="cultureIds" initialValue={this.props.currentClient.cultureIds}>
                <Select mode="multiple" allowClear={true} placeholder="Please select culture">
                  {Languages.All.map((x) => (
                    <Select.Option key={`cultureIds${x.id}`} value={x.id}>
                      {x.name} ({x.code})
                    </Select.Option>
                  ))}
                </Select>
              </GenericFormItem>
            </Form>
          </Col>
        </Row>
      );
    }
  }
);

// Full Sync Form
let FullSyncForm = Form.create({
  onFieldsChange(props: FullSyncFormProps, changedFields: any[]) {
    props.onChange(changedFields);
  },
})(
  class extends React.Component<FullSyncFormProps & FormComponentProps> {
    constructor(props: FullSyncFormProps & FormComponentProps) {
      super(props);
    }

    private validateState = (rule, value, callback) => {
      value ? callback() : callback(' ');
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
      let translatedLabel = this.props.translate(translationId);

      let rules = [];

      if (required) {
        rules.push({ required: true, message: this.props.translate('admin.common.requiredRule') });
      }

      if (id === 'stateId') {
        rules.push({ validator: this.validateState });
      }

      if (visible) {
        return (
          <Form.Item label={translatedLabel}>
            {this.props.form.getFieldDecorator(id, {
              initialValue: initialValue,
              rules: rules,
            })(inputType)}
          </Form.Item>
        );
      }
    }

    private renderCleverDistrictIdItem(translationId: string, id: string, initialValue) {
      let translatedLabel = this.props.translate(translationId);

      return (
        <Form.Item label={translatedLabel}>
          {this.props.form.getFieldDecorator(id, {
            initialValue: initialValue,
          })(<Input autoComplete="off" />)}
        </Form.Item>
      );
    }

    private renderDistrictClassLinkTenantIdItem(translationId: string, id: string, initialValue) {
      let translatedLabel = this.props.translate(translationId);

      return (
        <Form.Item label={translatedLabel}>
          {this.props.form.getFieldDecorator(id, {
            initialValue: initialValue,
          })(<Input autoComplete="off" />)}
        </Form.Item>
      );
    }

    render() {
      let choosenClientType = this.props.clientTypes.find((x) => x.value === this.props.currentClient.clientTypeId).key.toLowerCase();

      let ssoDistrictId = choosenClientType === 'district' ? 'cleverDistrictId' : '';

      let syncStudents = choosenClientType === 'district' ? 'syncStudents' : '';

      let syncTeachers = choosenClientType === 'district' ? 'syncTeachers' : '';

      let fullSync = choosenClientType === 'district' ? 'fullSync' : '';

      let isStateClient = choosenClientType === 'state';

      let classLinkTenantId = choosenClientType === 'district' ? 'classLinkTenantId' : '';
      let syncClassLinkStudentsAndTeachers = choosenClientType === 'district' ? 'syncClassLinkStudentsAndTeachers' : '';

      return (
        <Row>
          <Col span={12}>
            <Form className="admin-form">
              {this.renderCleverDistrictIdItem('admin.addEditClient.' + ssoDistrictId, 'cleverDistrictId', this.props.currentClient.cleverDistrictId)}

              {this.renderStandardFormItem(
                'admin.addEditClient.' + syncStudents,
                'syncStudents',
                this.props.currentClient.syncStudents,
                <RadioGroup name="syncStudents" value={this.props.currentClient.syncStudents}>
                  <Radio value={true} checked={this.props.currentClient.syncStudents === true}>
                    {this.props.translate('admin.addEditClient.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentClient.syncStudents === false}>
                    {this.props.translate('admin.addEditClient.no')}
                  </Radio>
                </RadioGroup>,
                !isStateClient,
                false
              )}

              {this.renderStandardFormItem(
                'admin.addEditClient.' + syncTeachers,
                'syncTeachers',
                this.props.currentClient.syncTeachers,
                <RadioGroup name="syncTeachers" value={this.props.currentClient.syncTeachers}>
                  <Radio value={true} checked={this.props.currentClient.syncTeachers === true}>
                    {this.props.translate('admin.addEditClient.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentClient.syncTeachers === false}>
                    {this.props.translate('admin.addEditClient.no')}
                  </Radio>
                </RadioGroup>,
                !isStateClient,
                false
              )}

              {this.renderStandardFormItem(
                'admin.addEditClient.' + fullSync,
                'fullSync',
                this.props.currentClient.fullSync,
                <RadioGroup name="fullSync" value={this.props.currentClient.fullSync}>
                  <Radio value={true} checked={this.props.currentClient.fullSync === true}>
                    {this.props.translate('admin.addEditClient.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentClient.fullSync === false}>
                    {this.props.translate('admin.addEditClient.no')}
                  </Radio>
                </RadioGroup>,
                !isStateClient,
                false
              )}

              {this.renderDistrictClassLinkTenantIdItem('admin.addEditClient.' + classLinkTenantId, 'classLinkTenantId', this.props.currentClient.classLinkTenantId)}

              {this.renderStandardFormItem(
                'admin.addEditClient.' + syncClassLinkStudentsAndTeachers,
                'syncClassLinkStudentsAndTeachers',
                this.props.currentClient.syncClassLinkStudentsAndTeachers,
                <RadioGroup name="syncClassLinkStudentsAndTeachers" value={this.props.currentClient.syncClassLinkStudentsAndTeachers}>
                  <Radio value={true} checked={this.props.currentClient.syncClassLinkStudentsAndTeachers === true}>
                    {this.props.translate('admin.addEditClient.yes')}
                  </Radio>
                  <Radio value={false} checked={this.props.currentClient.syncClassLinkStudentsAndTeachers === false}>
                    {this.props.translate('admin.addEditClient.no')}
                  </Radio>
                </RadioGroup>,
                !isStateClient,
                false
              )}
            </Form>
          </Col>
        </Row>
      );
    }
  }
);

class AddEditClient extends React.Component<AddEditClientProps, AddEditClientState> {
  private formRef: React.Component<FormComponentProps>;

  constructor(props: AddEditClientProps) {
    super(props);
    bindAllOfThis(this, AddEditClient.prototype);

    let clientId = parseInt(this.props.match.params.id, 10);

    let currentClient: UpdateClientDTO = {
      clientId: clientId,
      clientTypeId: 1,
      clientName: '',
      districtSchoolName: '',
      cleverDistrictId: '',
      syncStudents: false,
      syncTeachers: false,
      fullSync: false,
      fullSyncEndTimeStudents: null,
      fullSyncEndTimeTeachers: null,
      countryId: null,
      stateId: null,
      cultureIds: [],
      modifiedBy: '',
      modifiedDate: null,
      classLinkTenantId: null,
      syncClassLinkStudentsAndTeachers: false,
    };

    this.state = {
      loading: true,
      isSubmitting: false,
      clientTypes: [],
      countries: [],
      states: [],
      currentClient: currentClient,
    };
  }

  componentWillMount() {
    ClientApiController.getClientTypes()
      .then((result) => {
        this.setState({ clientTypes: result.data }, this.getCountries);
      })
      .catch((e) => {
        message.error(this.props.translate('admin.common.messageClientTypeError'));
      });
  }

  private getCountries() {
    StateApiController.getCountries()
      .then((result) => {
        this.setState({ countries: result.data.keyValues }, this.fillForm);
      })
      .catch((e) => {
        message.error(this.props.translate('admin.common.messageCountryError'));
      });
  }

  private fillForm(): void {
    if (this.state.currentClient.clientId) {
      ClientApiController.getClient(this.state.currentClient.clientId)
        .then((result) => {
          this.setState(
            {
              loading: false,
              currentClient: result.data,
            },
            this.getStates
          );
        })
        .catch((e) => {
          message.error(this.props.translate('admin.addEditClient.messageRetrieveError'));
        });
    } else {
      let firstCountryId = this.state.countries.find((_) => true).value;
      let cultureIds = Languages.All.map((x) => x.id);
      let newCurrentClient = { ...this.state.currentClient, ...({ countryId: firstCountryId, cultureIds: cultureIds } as UpdateClientDTO) };

      this.setState(
        {
          loading: false,
          currentClient: newCurrentClient,
        },
        this.getStates
      );
    }
  }

  private getStates(maybeCountryId?: number) {
    let countryId = maybeCountryId ? maybeCountryId : this.state.currentClient.countryId;
    let includeClientStates = this.state.currentClient.clientId ? true : false;

    if (countryId) {
      StateApiController.getStatesByCountry(countryId, includeClientStates)
        .then((result) => {
          let stateId = this.state.currentClient.clientId ? this.state.currentClient.stateId : result.data.keyValues.find((_) => true).value;

          let newCurrentClient = { ...this.state.currentClient, ...({ stateId: stateId } as UpdateClientDTO) };

          this.setState({
            states: result.data.keyValues,
            currentClient: newCurrentClient,
          });
        })
        .catch((e) => {
          message.error(this.props.translate('admin.common.messageStateError'));
        });
    }
  }

  private handleInputChange(changedFields: any[]): void {
    let newState = {};
    for (var key in changedFields) {
      if (changedFields.hasOwnProperty(key)) {
        let field: any = changedFields[key];

        if (key === 'countryId') {
          this.getStates(field.value);
        }

        if (key === 'fullSync') {
          if (field.value === true) {
            newState['syncStudents'] = true;
            newState['syncTeachers'] = true;
          } else {
            newState['syncStudents'] = false;
            newState['syncTeachers'] = false;
          }
        }

        newState[key] = field.value;
      }
    }
    this.setState({
      currentClient: { ...this.state.currentClient, ...newState },
    });
  }

  private addClient(): void {
    let AddClientDTO: AddClientDTO = {
      clientName: this.state.currentClient.clientName,
      clientTypeId: this.state.currentClient.clientTypeId,
      districtSchoolName: this.state.currentClient.districtSchoolName,
      countryId: this.state.currentClient.countryId,
      stateId: this.state.currentClient.stateId,
      cultureIds: this.state.currentClient.cultureIds,
    };

    ClientApiController.addClient(AddClientDTO)
      .then((result) => {
        message.success(this.props.translate('admin.addEditClient.messageAdd'));
        this.setState({ isSubmitting: false });
        let redirectUrl = Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT, result.data.data);
        this.props.history.push(redirectUrl);
      })
      .catch((e) => {
        message.error(this.props.translate('admin.addEditClient.messageAddError'));
        this.setState({ isSubmitting: false });
      });
  }

  private updateClient(): void {
    ClientApiController.updateClient(this.state.currentClient)
      .then((result) => {
        message.success(this.props.translate('admin.addEditClient.messageUpdate'));
        this.setState({ isSubmitting: false });
        this.handleRedirect();
      })
      .catch((e) => {
        message.error(this.props.translate('admin.addEditClient.messageUpdateError'));
        this.setState({ isSubmitting: false });
      });
  }

  private validateAndSubmit() {
    const hasCleverInfo = this.state.currentClient.cleverDistrictId != null && this.state.currentClient.cleverDistrictId.trim() !== '';
    const hasClassLinkInfo = this.state.currentClient.classLinkTenantId != null && this.state.currentClient.classLinkTenantId > 0;

    if( hasCleverInfo && hasClassLinkInfo) {
      this.formRef.props.form.setFields({
        cleverDistrictId: {
            value: this.state.currentClient.cleverDistrictId,
            errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
        },
        classLinkTenantId: {
            value: this.state.currentClient.classLinkTenantId,
            errors: [new Error('"Please only enter a value for either CleverId or ClassLinkTenantId, not both."')],
        }
      });
      return;
    }

    this.formRef.props.form.validateFields((error: any, values: any) => {
      if (!error) {
        this.setState({ isSubmitting: true });
        this.state.currentClient.clientId ? this.updateClient() : this.addClient();
      }
    });
  }

  private handleSubmit = (e: any) => {
    e.preventDefault();

    if (!this.state.currentClient.cleverDistrictId && !this.state.currentClient.classLinkTenantId) {
      this.validateAndSubmit();
    } else {
      // validate Clever District Id
      // this article helped with figuring out how to do async validation:
      // http://blog.frajtak.cz/2019/12/communicating-server-side-input-validation-failures-with-graphql-and-ant-design-form/
      if (this.state.currentClient.cleverDistrictId != null && this.state.currentClient.cleverDistrictId.trim() !== '') {
        const client: UpdateClientDTO = {
          ...this.state.currentClient,
          cleverDistrictId: this.state.currentClient.cleverDistrictId,
        };

        ClientApiController.isDuplicateCleverDistrictId(client)
          .then((result) => {
            if (result.data === true) {
              this.formRef.props.form.setFields({
                cleverDistrictId: {
                  value: this.state.currentClient.cleverDistrictId,
                  errors: [new Error('"This CleverId is already being used"')],
                },
              });
            } else {
              this.validateAndSubmit();
            }
          })
          .catch((e) => this.validateAndSubmit());
      } else if (this.state.currentClient.classLinkTenantId != null && this.state.currentClient.classLinkTenantId > 0) {
        const client: UpdateClientDTO = {
          ...this.state.currentClient,
          classLinkTenantId: this.state.currentClient.classLinkTenantId,
        };

        ClientApiController.isDuplicateClassLinkTenantId(client)
          .then((result) => {
            if (result.data === true) {
              this.formRef.props.form.setFields({
                classLinkTenantId: {
                  value: this.state.currentClient.classLinkTenantId,
                  errors: [new Error('"This ClassLinkTenantId is already being used"')],
                },
              });
            } else {
              this.validateAndSubmit();
            }
          })
          .catch((e) => this.validateAndSubmit());
      }
    }
  }

  private handleRedirect(): void {
    let redirectUrl = Routes.getRoute(Routes.ADMIN_CLIENTS);
    this.props.history.push(redirectUrl);
  }

  private handleCancel(e): void {
    this.props.history.push(Routes.ADMIN_CLIENTS);
  }

  private renderClientSubscriptions(): JSX.Element {
    let dataTableProps = {
      clientId: this.state.currentClient.clientId,
    } as ClientSubscriptionsProps;

    if (this.state.currentClient.clientId) {
      return <ClientSubscriptions {...dataTableProps} />;
    }
  }

  private renderAdminFullSyncReports(): JSX.Element {
    const fullSyncCompletionEndDateStudents = this.state.currentClient.fullSyncEndTimeStudents !== null ? new Date(this.state.currentClient.fullSyncEndTimeStudents.toLocaleString()) : '';

    const fullSyncCompletionEndDateTeachers = this.state.currentClient.fullSyncEndTimeTeachers !== null ? new Date(this.state.currentClient.fullSyncEndTimeTeachers.toLocaleString()) : '';

    const lastSyncModifiedBy = this.state.currentClient.modifiedBy !== null ? this.state.currentClient.modifiedBy : '';

    const lastSyncModifiedDate = this.state.currentClient.modifiedDate !== null ? new Date(this.state.currentClient.modifiedDate.toLocaleString()) : '';

    let dataTableProps = {
      districtId: this.state.currentClient.districtId,
      districtName: this.state.currentClient.clientName,
      fullSyncCompletionEndDateStudents: fullSyncCompletionEndDateStudents,
      fullSyncCompletionEndDateTeachers: fullSyncCompletionEndDateTeachers,
      lastSyncModifiedBy: lastSyncModifiedBy,
      lastSyncModifiedDate: lastSyncModifiedDate,
    };

    if (this.state.currentClient.districtId) {
      return <AdminFullSyncReports {...dataTableProps} />;
    }
  }

  render() {
    if (this.state.loading) {
      return <Spin />;
    }

    let formProps = {
      currentClient: this.state.currentClient,
      clientTypes: this.state.clientTypes,
      countries: this.state.countries,
      states: this.state.states,
      translate: this.props.translate,
      onChange: this.handleInputChange,
    } as ClientFormProps;

    let syncFormProps = {
      currentClient: this.state.currentClient,
      clientTypes: this.state.clientTypes,
      countries: this.state.countries,
      states: this.state.states,
      translate: this.props.translate,
      onChange: this.handleInputChange,
    } as FullSyncFormProps;

    let choosenClientType = this.state.clientTypes.find((x) => x.value === this.state.currentClient.clientTypeId).key.toLowerCase();

    let isDistrict = !(choosenClientType === 'district');

    return (
      <div className="full-sync-report">
        <h2>{this.state.currentClient.clientId ? this.state.currentClient.clientName : this.props.translate('admin.addEditClient.addHeader')}</h2>

        <ClientForm wrappedComponentRef={(ref) => (this.formRef = ref)} {...formProps} />

        <div hidden={isDistrict}>
          <br />
          <br />
          <Divider type="horizontal" />
          <h3>{this.props.translate('admin.addEditClient.fullSyncConfiguration')}</h3>

          <FullSyncForm wrappedComponentRef={(ref) => (this.formRef = ref)} {...syncFormProps} />
        </div>

        <div>
          <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
            {this.props.translate('admin.common.saveButton')}
          </Button>
          <Divider type="vertical" />
          <Button onClick={this.handleCancel}>{this.props.translate('common.back')}</Button>
        </div>

        <div hidden={isDistrict}>{this.renderAdminFullSyncReports()}</div>

        <br />
        <br />
        <Divider type="horizontal" />
        {this.renderClientSubscriptions()}
      </div>
    );
  }
}

export default withLocalize(AddEditClient);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditClient.tsx